import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ReturnIconsPayload } from "src/app/models/shared/return-icons-payload";
import { UtilityService } from "src/app/services/utility.service";

@Injectable()
export class IconResolver implements Resolve<Observable<ReturnIconsPayload>> {

    constructor(private utilityService: UtilityService) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Observable<ReturnIconsPayload>> {
        const response = this.utilityService.getIcons()
            .pipe(map(response => {
                if (response.success) {
                    return response.payload;
                }
                else {
                    return <ReturnIconsPayload>{
                        icons: []
                    };
                }
            }));
        const responsePromise = new Promise<Observable<ReturnIconsPayload>>((resolve, reject) => { resolve(response) });
        return responsePromise;
    }

}